import transmedicsCarImg from '../../../../assets/transmedicsCar.png';
import transmedicsPlaneImg from '../../../../assets/transmedicsPlane.png';

const PLANE_STYLE_ACTIVE = {
  opacity: 1,
  transform: 'translateY(0)',
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 1,
} as const;
const PLANE_STYLE_HIDDEN = {
  opacity: 0,
  transform: 'translateY(-20px)',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
} as const;
const CAR_STYLE_ACTIVE = {
  opacity: 1,
  transform: 'translateY(0)',
  position: 'relative',
  top: 0,
  left: 0,
  zIndex: 2,
} as const;
const CAR_STYLE_HIDDEN = {
  opacity: 0,
  transform: 'translateY(20px)',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 2,
} as const;

type TransportIconProps = {
  isGround: boolean;
};

export const TransportIcon = ({ isGround }: TransportIconProps) => (
  <div
    className="relative h-[75px]"
    role="img"
    aria-label={isGround ? 'Ground transport active' : 'Air transport active'}
  >
    <img
      src={transmedicsPlaneImg}
      alt=""
      aria-hidden="true"
      className="h-[75px] object-contain transition-all duration-1000 ease-in-out"
      style={isGround ? PLANE_STYLE_HIDDEN : PLANE_STYLE_ACTIVE}
    />
    <img
      src={transmedicsCarImg}
      alt=""
      aria-hidden="true"
      className="h-[75px] object-contain transition-all duration-1000 ease-in-out"
      style={isGround ? CAR_STYLE_ACTIVE : CAR_STYLE_HIDDEN}
    />
    <span className="sr-only">{isGround ? 'Traveling by ground vehicle' : 'Traveling by aircraft'}</span>
  </div>
);
